import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import ContentBlockItem from "../ContentBlockItem";
import {
  Dialog,
  DialogScroll,
  BottomSheet,
} from "@ebscois/react-component-library";
import useContentPreprocessors from "../../hooks/useContentPreprocessors";
import DialogWindow from "../DialogWindow";
import FullTextLinks from "../FullTextLinks";
import { affordances } from "../../util/analytics";

const ContentBlock = ({
  content,
  hfcData,
  tablesContent,
  updates,
  isValidSplitContent,
  idToSectionMap,
  activeSectionIndex,
  transformData,
  multimedia,
  referenceData,
  handleOpenPDF,
  handleOpenLightBoxImage,
  handleOpenLightBoxVideo,
  handleHFCDialogOpen,
  selectedReferences,
  referenceSectionId,
  careInterventionsSectionId,
  userExperience,
  setIsDialogOpen,
  setTableData,
  ancillaryData,
  setIsEvidenceBottomSheetOpen,
  handleTocItemClick,
  isDesktopDevice,
  isMobileDevice,
  isTabletDevice,
  loe,
  toc,
  telemetryData,
  slugPubType,
  slugTitle,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [docId, setDocId] = useState([]);
  const [docType, setDocType] = useState([]);
  const [additionalFtLinks, setAdditionalLinks] = useState([]);
  const [isBottomSheetVisible, setBottomSheetVisibility] = useState(false);
  const [bottomSheetContent, setBottomSheetContent] = useState("");
  const closeBottomSheet = () => {
    setBottomSheetVisibility(false);
  };
  const closeDialogWindow = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  const openFtfDialog = (id, type, localAdditionalFtLinks) => {
    setDocId(id);
    setDocType(type);
    setAdditionalLinks(localAdditionalFtLinks);
    setIsModalOpen(true);
  };
  const openBottomSheet = (refContent) => {
    setBottomSheetVisibility(true);
    setBottomSheetContent(refContent);
  };

  const { modalAssets, preProcessorInstance } = useContentPreprocessors({
    updates,
    hfcData,
    tablesContent,
    transformData,
    multimedia,
    referenceData,
    referenceSectionId,
    userExperience,
    ancillaryData,
    handleOpenPDF,
    handleOpenLightBoxImage,
    handleOpenLightBoxVideo,
    handleHFCDialogOpen,
    setIsDialogOpen,
    setTableData,
    setIsEvidenceBottomSheetOpen,
    isMobileDevice,
    isTabletDevice,
    loe,
    openFtfDialog,
    openBottomSheet,
    slugPubType,
    slugTitle,
    telemetryData: { ...telemetryData },
  });

  return !preProcessorInstance ? (
    <></>
  ) : (
    <>
      <ContentBlockItem
        content={content}
        isValidSplitContent={isValidSplitContent}
        idToSectionMap={idToSectionMap}
        activeSectionIndex={activeSectionIndex}
        selectedReferences={selectedReferences}
        preProcessors={preProcessorInstance}
        referenceSectionId={referenceSectionId}
        careInterventionsSectionId={careInterventionsSectionId}
        useNumberedRef={userExperience.useNumberedRef}
        handleTocItemClick={handleTocItemClick}
        isDesktopDevice={isDesktopDevice}
        toc={toc}
        telemetryData={telemetryData}
        slugPubType={slugPubType}
      />
      <Dialog
        onRequestClose={() => modalAssets.setIsModalOpen(false)}
        isOpen={modalAssets.isModalOpen}
        maxWidth="lg"
        hasMaxHeight={true}
      >
        <DialogScroll>{modalAssets.modalBody}</DialogScroll>
      </Dialog>
      <DialogWindow
        isOpened={isModalOpen}
        pageType="contentPageModal"
        handleClose={closeDialogWindow}
        windowMessage={
          <FullTextLinks
            docId={docId}
            docType={docType}
            additionalFtLinks={additionalFtLinks}
            telemetryData={{
              ...telemetryData,
              affordance: affordances.TOPIC_INLINE,
            }}
          />
        }
      />
      <BottomSheet
        delay={100}
        closeable={true}
        isOpen={isBottomSheetVisible}
        onClose={closeBottomSheet}
        speed={1000}
        transition="slide"
        data-testid="bottomSheet"
      >
        {bottomSheetContent}
      </BottomSheet>
    </>
  );
};

// TODO: We need to add remaining props and their defaults
ContentBlock.propTypes = {
  userExperience: PropTypes.shape({
    shouldTrackUsage: PropTypes.bool,
  }),
  hfcData: PropTypes.shape({
    hfc: PropTypes.shape({
      dialog: PropTypes.string,
      dialogTitle: PropTypes.string,
    }),
  }),
  handleOpenPDF: PropTypes.func.isRequired,
  handleHFCDialogOpen: PropTypes.func,
};

ContentBlock.defaultProps = {
  userExperience: {},
};

ContentBlock.displayName = "ContentBlock";

export default ContentBlock;
